// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7f77f7fe","667":"6d3f1a1b"}[chunkId] + ".chunk.js";
};